import { colors } from "~/styleguide";

/**
 * React Select custom styling
 * See: https://react-select.com/styles
 */

const selectBase = {
    borderColor: colors.black,
    color: colors.black,

    ":hover": {
        borderColor: colors.blue,
        color: colors.blue
    },

    ":focus": {
        borderColor: colors.blue,
        color: colors.blue
    }
};

export const selectStyles = {
    width: "20%",

    maxWidthTabletLandscape: {
        marginBottom: 20,

        minWidthMobile: {
            width: "calc(100% - 10px)",
            marginRight: 0
        },

        maxWidthMobile: {
            width: "100%",
            marginRight: "0 !important"
        }
    },

    // Main component wrapper
    "& .react-select__control": {
        ...selectBase,

        height: 54,
        cursor: "pointer",
        borderRadius: 6,
        overflow: "hidden"
    },

    // Selected item container
    "& .react-select__value-container": {
        paddingTop: 4,
        paddingRight: 30
    },

    // Hide option X, clear X, separator
    "& .react-select__indicator-separator": { display: "none" },
    // "& .react-select__multi-value__remove": { display: "none" },
    "& .react-select__clear-indicator": { display: "none" },

    // Drop down arrow
    "& .react-select__dropdown-indicator": {
        ...selectBase,
        position: "absolute",
        right: 0,
        top: "50%",
        zIndex: 2,
        transform: "translateY(-50%)"
    },

    // View All text
    "& .react-select__placeholder": { color: colors.black },

    // Selection items
    "& .react-select__multi-value__label": {
        fontSize: 11,
        paddingH: 4,
        color: colors.black,
        background: colors.grey
    },

    // Entry remove button
    "& .react-select__multi-value__remove": {
        paddingH: 2
    },

    // Select dropdown wrapper
    "& .react-select__menu": {
        borderColor: colors.black,
        borderStyle: "solid",
        borderWidth: 1
    }
};
